// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1K16o","header":"Card_header__2Ay-w","active":"Card_active__2Rpxf"};